<template>
  <div :class="{
    'fixed-header': !isHeaderHidden,
    'hidden-header': isHeaderHidden,
    'show-header': showHeader,
  }">
      <b-container class="header-container"  :class="{ 'logo-link-menu-open': isMobileMenuOpen }" :fluid="isMobile">
        <b-row>
        <b-col col sm="4" md="4" lg="4">
          <div class="header-left">
          <div  @click="closeMenu()">
            <router-link to="/" class="logo-link">
              <img class="icon-shelter" src="../assets/img/agatis-logo.svg" alt="Agatis logo">
            </router-link>
          </div>
        </div>
        </b-col>
        <b-col col sm="8" md="8" lg="8">
          <div v-if="isMobile" class="d-flex justify-content-end align-items-center">
            <div class="hamburger-menu" @click="toggleMobileMenu" :class="{ 'hamburger-menu-open': isMobileMenuOpen }">
              <div class="bar bar-1"></div>
              <div class="bar bar-2"></div>
              <div class="bar bar-3"></div>
            </div>
          </div>
          <b-nav v-else class="nav-header-container">
              <b-nav-item v-for="section in sections" :key="section.hash" :to="{ path: '/', hash: section.hash }" @click="scrollToSection(section.id)">
                {{ $t(section.label) }}
              </b-nav-item>
              <b-nav-item :to="{ path: '/projects' }">
               projects
              </b-nav-item>
          </b-nav>
        </b-col>
        <b-col sm="12" md="12" lg="12">
          <div v-if="isMobile" class="mobile-menu" :class="{ 'mobile-menu-open': isMobileMenuOpen }">
            <b-nav class="nav-header-container">
              <b-nav-item v-for="section in sections" :key="section.hash" :to="{ path: '/', hash: section.hash }" @click="scrollToSection(section.id); closeMenu()">
                {{ $t(section.label) }}
              </b-nav-item>
              <b-nav-item :to="{ path: '/projects' }" @click="closeMenu">
               projects
              </b-nav-item>
            </b-nav>
          </div></b-col>
      </b-row>
      </b-container>
  </div>
</template>

<script>

export default {
  data () {
    return {
      isHeaderHidden: false,
      prevScrollPos: 0,
      showHeader: false,
      isMobile: false,
      isMobileMenuOpen: false,
      sections: [
        { id: 'aboutAsSection', hash: '#aboutAsSection', label: 'about' },
        { id: 'gameSection', hash: '#gameSection', label: 'game' },
        { id: 'howToPlay', hash: '#howToPlay', label: 'how_to_play' }
      ]
    }
  },
  watch: {
    $route (to, from) {
      const sectionId = to.hash.replace('#', '')
      if (sectionId) {
        this.scrollToSection(sectionId)
      }
    },
    isMobileMenuOpen (newValue) {
      if (newValue) {
        document.body.classList.add('no-scroll')
      } else {
        document.body.classList.remove('no-scroll')
      }
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
    this.isMobile = this.$isMobile()
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll () {
      const currentScrollPos = window.pageYOffset
      if (currentScrollPos > this.prevScrollPos) {
        this.isHeaderHidden = true
      } else {
        this.isHeaderHidden = false
      }
      this.prevScrollPos = currentScrollPos
      if (currentScrollPos < 30) {
        this.showHeader = false
      } else {
        this.showHeader = true
      }
    },
    toggleMobileMenu () {
      this.isMobileMenuOpen = !this.isMobileMenuOpen
    },
    scrollToSection (sectionId) {
      this.$nextTick(() => {
        const targetElement = document.getElementById(sectionId)

        if (targetElement) {
          const yOffset = -80
          const y = targetElement.getBoundingClientRect().top + window.pageYOffset + yOffset
          window.scrollTo({
            top: y,
            behavior: 'smooth'
          })

          if (this.isMobile) {
            this.isMobileMenuOpen = false
          }
        }
      })
    },
    closeMenu () {
      this.isMobileMenuOpen = false
      this.$nextTick(() => {
        this.showHeader = false
        this.isHeaderHidden = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/sass/app.scss";
  .header-container{
    @media screen and (min-width: 320px) {
      padding-top: 24px;
      padding-bottom: 24px;
    }
    @media screen and (min-width: 768px) {

    }
    @media screen and (min-width: 1440px) {
      padding-top: 32px;
      padding-bottom: 32px;
    }
    @media screen and (min-width: 1920px) {
    }
    .header-left{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .logo-link{
        img{
          width: 100%;
          @media screen and (min-width: 320px) {
            max-width: 114px;
            height: 48px;
          }
          @media screen and (min-width: 768px) {

          }
          @media screen and (min-width: 1440px) {
            max-width: 133px;
            height: 56px;
          }
          @media screen and (min-width: 1920px) {
          }
        }
      }
    }
    .nav-header-container{
      height: 100%;
      align-items: center;
      gap: 40px;
      a{
        color: #000;
        font-family: $main-font;
        font-style: normal;
        font-weight: 700;
        line-height: 28.8px;
        padding: 4px 0;
        @media screen and (min-width: 320px) {
          font-size: 24px;
        }
        @media screen and (min-width: 768px) {
        font-size: 18px;
        }
        @media screen and (min-width: 1440px) {
        font-size: 24px;
        }
        @media screen and (min-width: 1920px) {
        }
        &::first-letter{text-transform:uppercase;}
      }
    }
  }
  .header-container.logo-link-menu-open{
    background: #755B95;
    transition: max-height 0.9s ease, opacity 0.9s ease;
    .header-left{
        .logo-link{
          img{
            filter: invert(100%) sepia(5%) saturate(0%) hue-rotate(316deg) brightness(105%) contrast(107%);
          }
        }
      }
  }

  .fixed-header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 100;
    transition: transform 0.3s ease;
    background: #ffffff;
  }
  .show-header{
    background: #ffffff;
  }
  .hidden-header {
    height: 0;
    transform: translateY(-100%);
  }
  /*** Mobile ***/
  .hamburger-menu {
    border-radius: 16px;
    background: #755B95;
    width: 40px;
    height: 40px;
    padding: 0px 8px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: center;
    z-index: 9999;
    float: right;

    .bar {
      width: 100%;
      height: 3px;
      background-color: #ffffff;
      transition: 0.4s;

      &.bar-1 {
        transform: translateY(-3px) rotate(0deg);
      }
      &.bar-2 {
        transform: translateY(0px) rotate(0deg);
      }
      &.bar-3 {
        transform: translateY(3px) rotate(0deg);
      }
    }
    &.hamburger-menu-open {
      .bar-1 {
        background-color: #ffffff;
        transform: translateY(3px) rotate(45deg);
      }
      .bar-2 {
        opacity: 0;
      }
      .bar-3 {
        background-color: #ffffff;
        transform: translateY(-3px) rotate(-45deg);
      }
    }
  }

  .mobile-menu {
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 58vh;
    max-height: 0;
    overflow: hidden;
    padding: 15px 16px;
    background: #755B95;
    z-index: 1;
    opacity: 0;
    transition: max-height 0.3s ease, opacity 0.3s ease;
    display: flex;
    justify-content: flex-end;
    align-items: center;
     @media screen and (min-width: 320px) {
      background: linear-gradient(170deg, #755B95 85%, transparent 50%);
    }
    @media screen and (min-width: 768px) {
      background: linear-gradient(174deg, #755B95 85%, transparent 50%);
    }
    @media screen and (min-width: 1440px) {
      background: #755B95;
    }
    @media screen and (min-width: 1920px) {
    }
    .nav-header-container{
      display: none;
    }
  }

  .mobile-menu-open {
    max-height: 58vh;
    opacity: 1;
    .nav-header-container{
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 24px;
      .nav-item{
        .nav-link{
          color: #FFFF9F;
          font-size: 24px;
          font-style: normal;
          font-weight: 700;
          line-height: 28.8px;
        }
      }
    }
  }
</style>
